import { Button, Form, Input, Modal, Typography } from 'antd'
import { useState } from 'react'
import { toast } from 'react-toastify'
import { authService } from 'services'
import styled from 'styled-components'
const { Text } = Typography;
const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  .submit-btn {
    width: 100%;
  }
`
const ModalFooter = styled.div`
  display: flex;
     flex-direction: row;
    gap: 10px;
    justify-content: flex-end;
`
const ModalMessage = styled.div`
  display: flex;
    justify-content: center;
`

const ModalForgotPassword = ({ open, onCancel }) => {
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const [hideBtnConfirm, setHideBtnConfirm] = useState(false)
  const [messageSuccess, setMessageSuccess] = useState("")
  const [messageError, setMessageError] = useState("")

  const handleClose = () => {
    form.resetFields()
    setMessageError("")
    setMessageSuccess("")
    setHideBtnConfirm(false)
    onCancel()
  }

  const handleSubmit = () => {
    form.validateFields().then(async (values) => {
      setLoading(true)
      try {
        await authService.forgotPassword(
          values,
          (response) => {
            setMessageSuccess(response?.data?.message || 'Gửi email thất bại')
            setMessageError("")
            setHideBtnConfirm(true)
            setLoading(false)
          },
          (response) => {
            setMessageSuccess("")
            setMessageError(response?.message || 'Gửi email thất bại')
            setLoading(false)
          }
        )
      } catch (error) {
        setLoading(false)
        console.error('forgotPassword', error)
      }
    })
  }

  return (
    <Modal
      title={<p style={{ fontSize: '20px', fontWeight: 700 }}>Quên mật khẩu</p>}
      open={open}
      footer={false}
      onCancel={handleClose}
      maskClosable={false}
    >
      <ModalBody>
        <p className='title'>Vui lòng nhập email đã đăng ký tài khoản, sau đó ấn nút xác nhận</p>

        <Form form={form} layout='horizontal'>
          <Form.Item
            label='Email'
            name='email'
            rules={[
              { required: true, message: 'Vui lòng nhập email!' },
              {
                type: 'email',
                message: 'Email sai định dạng!',
              },
            ]}
          >
            <Input placeholder='Nhập email' />
          </Form.Item>
        </Form>
      </ModalBody>
      <ModalMessage>{messageSuccess != "" && <Text type="success">{messageSuccess}</Text>}
        {messageError != "" && <Text type="danger">{messageError}</Text>}</ModalMessage>
      <ModalFooter>
        {!hideBtnConfirm && <Button type='primary' loading={loading} disabled={loading} onClick={handleSubmit}>
          Xác nhận
        </Button>}
        <Button onClick={handleClose}>
          Thoát
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default ModalForgotPassword
